exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forgot-password-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%; }\n  .forgot-password-form__row {\n    margin-bottom: 2em; }\n  .forgot-password-form__input {\n    width: 100%;\n    height: 100%;\n    padding: 0.625em 0.625em 0.625em 0;\n    border: none;\n    outline: none;\n    font-size: 1rem; }\n    .forgot-password-form__input:-webkit-autofill {\n      -webkit-box-shadow: 0 0 0 30px white inset; }\n  .forgot-password-form__button {\n    width: 100%;\n    padding: 0.8125em 0;\n    border: none;\n    background: #5ec8ff;\n    color: #fff;\n    font-size: 1rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    transition: 150ms;\n    cursor: pointer;\n    outline: none; }\n    .forgot-password-form__button:hover {\n      background: #102a37; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/popups/forgot-password/forgot-password.component.scss
// module id = ../../../../../src/app/popups/forgot-password/forgot-password.component.scss
// module chunks = main